export default (t) => ({
  hidden: true,
  element: 'bpmn:ServiceTask',
  service: 'whatsapp',
  title: t('script.controlls.whatsapp.title'),
  helplink: '',
  group: 'communication',
  class: 'other',
  color: '#60a5c0',
  border: 2,
  icon: 'anticon-icon social-whatsapp',
  icon_scale: 1,
  offset_x: 4,
  offset_y: -16,
  toolbar_offset_x: 0,
  toolbar_offset_y: -15,
  icon_rotate: 0,
  priority: 11,
  config: [
    {
      id: 'commonSection',
      name: t('script.common.general'),
      type: 'group',
    },
    {
      id: 'name',
      name: t('script.common.title'),
      type: 'text',
      readOnly: false,
      config: {
        defaultEmptyValue: t('script.controlls.whatsapp.title'),
        type: 'text',
        valueType: 'const',
        map: 'input',
      },
    },
    {
      id: 'description',
      name: t('script.common.description'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        valueType: 'const',
        map: 'input',
      },
    },
    {
      id: 'section_connection',
      name: t('script.controlls.whatsapp.sectionConnection'),
      type: 'group',
    },
    {
      id: 'service',
      name: t('script.controlls.whatsapp.service'),
      type: 'object',
      readOnly: false,
      config: {
        catalogId: '$authServices',
        multiselect: false,
        enableCreate: true,
        enableSelect: true,
        view: 'list',
        map: 'input',
      },
    },
    {
      id: 'section_parameters',
      name: t('script.controlls.whatsapp.sectionParameters'),
      type: 'group',
    },
    {
      id: 'action',
      name: t('script.controlls.whatsapp.action'),
      type: 'radiobutton',
      readOnly: false,
      config: {
        items: [
          {
            id: 'sendMessage',
            name: t('script.controlls.whatsapp.sendMessage'),
          },
          {
            id: 'sendLocation',
            name: t('script.controlls.whatsapp.sendLocation'),
          },
          {
            id: 'sendContact',
            name: t('script.controlls.whatsapp.sendContact'),
          },
          {
            id: 'sendReaction',
            name: t('script.controlls.whatsapp.sendReaction'),
          },
          {
            id: 'forwardMessage',
            name: t('script.controlls.whatsapp.forwardMessage'),
          },
          {
            id: 'editMessage',
            name: t('script.controlls.whatsapp.editMessage'),
          },
          {
            id: 'deleteMessage',
            name: t('script.controlls.whatsapp.deleteMessage'),
          },
        ],
        type: 'select',
        map: 'input',
        defaultEmptyValue: 'sendMessage',
      },
    },
    {
      id: 'dialog',
      name: t('script.controlls.whatsapp.dialog'),
      hint: t('script.controlls.whatsapp.dialogHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $in: [
            'sendMessage',
            'sendLocation',
            'sendContact',
            'sendReaction',
            'forwardMessage',
            'editMessage',
            'deleteMessage',
          ],
        },
      },
    },
    // {
    //   id: 'outputDialog',
    //   name: t('script.controlls.whatsapp.outputDialog'),
    //   hint: t('script.controlls.whatsapp.dialogHint'),
    //   type: 'text',
    //   readOnly: false,
    //   config: {
    //     map: 'input',
    //     type: 'multiline',
    //     theme: 'script',
    //     placeholder: t('script.common.valueExpression'),
    //   },
    //   visible: {
    //     action: {
    //       $in: ['forwardMessage'],
    //     },
    //   },
    // },
    {
      id: 'messageId',
      name: t('script.controlls.whatsapp.messageId'),
      hint: t('script.controlls.whatsapp.messageIdHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'multiline',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $in: ['editMessage', 'deleteMessage', 'sendReaction'],
        },
      },
    },
    {
      id: 'forwardMessageId',
      name: t('script.controlls.whatsapp.forwardMessageId'),
      hint: t('script.controlls.whatsapp.forwardMessageIdHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'multiline',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $in: ['forwardMessage'],
        },
      },
    },
    {
      id: 'location',
      name: t('script.controlls.whatsapp.location'),
      hint: t('script.controlls.whatsapp.locationHint'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $include: 'sendLocation',
        },
      },
    },
    {
      id: 'contact',
      name: t('script.controlls.whatsapp.contact'),
      hint: t('script.controlls.whatsapp.contactHint'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $include: 'sendContact',
        },
      },
    },
    {
      id: 'text',
      name: t('script.controlls.whatsapp.text'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $in: ['sendMessage', 'editMessage'],
        },
      },
    },
    {
      id: 'attachments',
      name: t('script.controlls.whatsapp.attachments'),
      hint: t('script.controlls.whatsapp.attachmentsHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'multiline',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $in: ['sendMessage'],
        },
      },
    },
    {
      id: 'attachmentsView',
      name: t('script.controlls.whatsapp.attachmentsView'),
      hint: t('script.controlls.whatsapp.attachmentsViewHint'),
      type: 'dropdown',
      readOnly: false,
      config: {
        items: [
          {
            id: 'media',
            name: 'Медиа',
            color: 'DFE0E0',
          },
          {
            id: 'document',
            name: 'Документы',
            color: 'DFE0E0',
          },
        ],
        defaultValue: true,
        multiselect: false,
        defaultEmptyValue: ['media'],
        map: 'input',
      },
      visible: {
        action: {
          $include: 'sendMessage',
        },
      },
    },
    {
      id: 'reaction',
      name: t('script.controlls.whatsapp.reaction'),
      hint: t('script.controlls.whatsapp.reactionHint'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $include: 'sendReaction',
        },
      },
    },
    {
      id: 'section_output',
      name: t('script.common.result'),
      type: 'group',
    },
    {
      id: 'output_body',
      name: t('script.controlls.whatsapp.saveResult'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'text',
        map: 'output',
        placeholder: t('script.common.variableName'),
      },
    },
  ],
  exits: [],
});
